
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFAA80","d":"M13.727 15.407c0-.536-.169-.978-.506-1.325-.336-.353-.898-.669-1.684-.946-.785-.284-1.397-.546-1.833-.786-1.453-.788-2.18-1.956-2.18-3.501 0-1.048.315-1.909.945-2.584.63-.675 1.484-1.076 2.563-1.202V3h1.497v2.082c1.085.158 1.924.625 2.517 1.4.592.77.889 1.774.889 3.01H13.67c0-.795-.178-1.42-.534-1.874-.35-.46-.826-.69-1.431-.69-.599 0-1.067.163-1.403.492-.337.328-.506.798-.506 1.41 0 .549.166.99.496 1.325.337.328.905.64 1.703.937.798.296 1.425.57 1.88.823.456.252.84.542 1.151.87.312.322.552.694.72 1.117.169.423.253.918.253 1.486 0 1.066-.324 1.93-.973 2.593-.642.662-1.54 1.054-2.694 1.174V21h-1.488v-1.836c-1.235-.139-2.186-.587-2.853-1.344C7.33 17.063 7 16.06 7 14.81h2.273c0 .796.197 1.41.59 1.846.399.436.96.653 1.684.653.71 0 1.25-.173 1.618-.52.375-.347.562-.808.562-1.382z"}})])
          )
        }
      }
    